import React, { useState, useRef, useEffect, useCallback } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import qs from "qs";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Input,
  Col,
  Row,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
  threeColumnFormItemLayout,
} from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onChange,
  onUpdateStatus,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onWarehouseSearch,
  onBranchSearch,
  onProjectSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import { sumBy, uniq } from "lodash";
import WarehouseFormModal from "../modals/WarehouseFormModal";
import { Link, useMatch, useNavigate, useParams } from "react-router-dom";
import numberFormatInt from "../../utils/numberFormatInt";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import validator from "validator";
import FormButtons from "../../commons/FormButtons";
import classNames from "classnames";
import {
  ACCESS_ADD,
  ACCESS_ADVANCE_SEARCH,
  ACCESS_OPEN,
  APPROVED,
  CANCELLED,
  FOR_APPROVAL,
  OPEN,
  STATUS_ALLOW_EDIT,
  STATUS_CLOSED,
  STATUS_PAID,
  STATUS_FULFILLED,
} from "../../utils/constants";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import AccountFormModal from "../modals/AccountFormModal";
import StockFormModal from "../modals/StockFormModal";
import computeItemDetails from "../../utils/computeItemDetails";
import confirm from "antd/lib/modal/confirm";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
const { Content } = Layout;
const { Panel } = Collapse;

const transaction = "purchase-orders";
const url = `/api/${transaction}/`;
const title = "Purchase Orders";

const initialItemValues = {
  stock: "",
  quantity: "",
  price: "",
  amount: "",
  supplier: "",
  notes: "",
};

const transaction_counter = {
  label: "PO #",
  key: "po_no",
};

const date_fields = ["date", "date_needed"];

export default function PurchaseOrderForm({}) {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [dr_numbers, setDrNumbers] = useState([]);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const [page_size, setPageSize] = useState(100);

  const [loading, setLoading] = useState(false);
  const [loading_state, setLoadingState] = useState({});
  const accountFormModal = useRef(null);
  const stockFormModal = useRef(null);
  const warehouseFormModal = useRef(null);
  const caseQuantityField = useRef(null);
  const quanttiyField = useRef(null);
  const casePriceField = useRef(null);
  const priceField = useRef(null);
  const amountField = useRef(null);
  const addItemButton = useRef(null);
  const stockField = useRef(null);

  const navigate = useNavigate();
  const [search_state, setSearchState] = useState({});

  const initialValues = {
    _id: null,
    date: moment(),
    items: [
      {
        ...initialItemValues,
      },
    ],
  };
  const [state, setState] = useState(initialValues);

  const records_column = [
    {
      title: "PO #",
      dataIndex: "po_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Date Needed",
      dataIndex: "date_needed",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Supplier",
      dataIndex: ["account", "name"],
    },

    {
      title: "PO Amount",
      dataIndex: ["total_amount"],
      align: "right",
      render: (value) => numberFormat(value),
    },

    {
      title: "Total Received Amount",
      dataIndex: ["total_received_amount"],
      align: "right",
      render: (value) => numberFormat(value),
    },

    {
      title: "Total Paid Amount",
      dataIndex: ["total_payment_amount"],
      align: "right",
      render: (value) => numberFormat(value),
    },
    {
      title: "Payment Status",
      dataIndex: ["payment_status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span>
            {round(record.total_amount) <= round(record.total_payment_amount)
              ? "PAID"
              : "UNPAID"}
          </span>
        );
      },
    },

    {
      title: "Status",
      dataIndex: ["status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span
            className={classNames("has-text-weight-bold", {
              "has-text-danger": status?.approval_status === CANCELLED,
            })}
          >
            {status?.approval_status || ""}
          </span>
        );
      },
    },
    {
      title: "Status Date",
      align: "center",
      dataIndex: ["status", "datetime"],
      render: (date) => date && moment(date).format("MM/DD/YYYY"),
    },
  ];

  const items_column = [
    {
      title: "",
      key: "action",
      width: 30,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() => {
                  setState((prevState) => {
                    const items = [...prevState.items];

                    items.splice(index + 1, 0, {
                      ...initialItemValues,
                    });

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }}
              >
                <i className="fas fa-plus"></i>
              </span>
            )}
        </span>
      ),
    },
    {
      title: "Item",
      dataIndex: ["stock"],
      render: (stock, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              disabled={!isEmpty(state.project?._id)}
              value={stock?.name}
              onSearch={(value) =>
                onStockSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const stock = options.stocks?.[index] || null;

                if (stock) {
                  getLatestCost({
                    stock_id: stock?._id,
                    date: state.date,
                    index: record_index,
                    current_po: state?._id,
                  });
                  setState((prevState) => {
                    const items = [...(prevState.items || [])];

                    items[record_index] = {
                      ...items[record_index],
                      stock,
                      // cost: stock.cost || 0,
                    };

                    if (items.length - 1 === record_index) {
                      items.push({
                        ...initialItemValues,
                        category: items[record_index].category,
                      });
                    }

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.stocks}
              column="display_name"
              onAddItem={() => stockFormModal.current.open(record_index)}
            />
          )
        );
      },
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 100,
    },
    {
      title: "Received Qty",
      dataIndex: ["received_quantity"],
      align: "center",
      width: 100,
    },
    {
      title: "Unit Cost",
      dataIndex: "cost",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN, FOR_APPROVAL, STATUS_ALLOW_EDIT].includes(
            state.status?.approval_status
          ) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.price}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          price: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            record.footer !== 1 && numberFormat(record.price)
          )}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: ["amount"],
      align: "right",
      width: 100,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN, FOR_APPROVAL, STATUS_ALLOW_EDIT].includes(
            state.status?.approval_status
          ) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];
                      let { quantity, price } = items[index];

                      if (quantity) price = round(value / quantity);

                      items[index] = {
                        ...items[index],
                        amount: value,
                        price,
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.amount)}`
          )}
        </span>
      ),
    },
    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  const estimates_column = [
    {
      title: "Item",
      dataIndex: ["stock", "name"],
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let estimates = [...state.estimates];

                      estimates[index] = {
                        ...estimates[index],
                        ...computeItemDetails({
                          ...estimates[index],
                          quantity: value,
                        }),
                      };

                      return {
                        ...prevState,
                        estimates,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },

    {
      title: "Est. Qty",
      dataIndex: ["estimate_quantity"],
      width: 80,
      align: "center",
    },

    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 100,
    },
    {
      title: "Unit Cost",
      dataIndex: "Price",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.price}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let estimates = [...state.estimates];

                      estimates[index] = {
                        ...estimates[index],
                        ...computeItemDetails({
                          ...estimates[index],
                          price: value,
                        }),
                      };

                      return {
                        ...prevState,
                        estimates,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            ""
          )}
        </span>
      ),
    },
    {
      title: "WW QTY",
      dataIndex: ["withdrawn_quantity"],
      align: "center",
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: ["amount"],
      align: "right",
      width: 100,
      render: (value) => numberFormat(value),
    },
  ];

  const getLatestCost = useCallback(({ stock_id, date, index, current_po }) => {
    if (stock_id && date) {
      console.log(current_po);
      axios
        .post("/api/purchase-orders/get-latest-cost", {
          stock_id,
          date,
          current_po,
        })
        .then((response) => {
          if (response.data) {
            setState((prevState) => {
              const items = [...prevState.items];
              items[index].price = response.data;
              return {
                ...prevState,
                items,
              };
            });
          }
        })
        .catch((err) => {
          return message.error("There was an error processing your request");
        });
    }
  }, []);

  useEffect(() => {
    const branch = auth?.user?.branches?.[0] || null;

    if (branch?._id) {
      setSearchState((prevState) => {
        return {
          ...prevState,
          branch,
        };
      });
    }

    setOptions((prevState) => {
      return {
        ...prevState,
        branches: auth?.user?.branches || [],
      };
    });

    return () => {};
  }, [auth.user.branches]);

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    (async () => {
      if (isEmpty(params?.id) && !isEmpty(search_state.branch?._id)) {
        setTimeout(() => {
          onSearch({
            page: current_page,
            page_size,
            search_keyword,
            url,
            setRecords,
            setTotalRecords,
            setCurrentPage,
            setErrors,
            advance_search: { ...search_state },
          });
        }, 300);
      }
    })();

    return () => {};
  }, [search_state.branch]);

  useEffect(() => {
    setState((prevState) => {
      const total_amount = sumBy(state.items, (o) => parseFloat(o.amount || 0));
      const gross_amount = total_amount;
      let net_amount = gross_amount;

      (state.discounts || []).forEach((discount) => {
        let discount_rate = validator.isNumeric(discount.toString())
          ? 1 - round(discount) / 100
          : 1;

        net_amount = net_amount * discount_rate;
      });

      const total_discount_amount = round(gross_amount - net_amount);

      return {
        ...prevState,
        total_amount,
        gross_amount,
        total_discount_amount,
      };
    });

    return () => {};
  }, [state.items, state.discounts]);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: {
          _id: params.id,
        },
        setState,
        setErrors,
        setRecords,
        url,
        date_fields,
      });
    }
    return () => {};
  }, []);

  useEffect(() => {
    const amount = round(
      round(round(item.case_quantity) * round(item.case_price)) +
        round(round(item.quantity) * round(item.price))
    );

    setItem((prevState) => {
      return {
        ...prevState,
        amount,
      };
    });

    return () => {};
  }, [item.case_quantity, item.quantity, item.case_price, item.price]);

  const can_edit = [OPEN, FOR_APPROVAL, null, undefined].includes(
    state.status?.approval_status
  );

  return (
    <Content className="content-padding">
      <StockFormModal
        setField={(stock, index) => {
          setState((prevState) => {
            const items = [...prevState.items];
            items[index].stock = stock;

            if (items.length - 1 === index) {
              items.push({
                ...initialItemValues,
              });
            }

            return {
              ...prevState,
              items,
            };
          });
        }}
        ref={stockFormModal}
      />
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />
      <AccountFormModal
        setField={(account) => {
          setState((prevState) => ({
            ...prevState,
            account,
          }));
        }}
        ref={accountFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={
              hasAccess({
                auth,
                access: ACCESS_ADD,
                location,
              })
                ? () => {
                    setState({
                      ...initialValues,
                      date: moment(),
                      branch: auth.user?.branches?.[0] || null,
                      items: [],
                      items: [
                        {
                          ...initialItemValues,
                        },
                      ],
                    });
                    setItem(initialItemValues);
                    setRecords([]);
                  }
                : null
            }
          />
        </div>
      </div>

      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>

                      <Col span={8}>
                        <SelectFieldGroup
                          label="Account"
                          value={search_state.account?.name}
                          onFocus={() => {
                            onSupplierSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onSupplierSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const account = options.accounts?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              account,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.accounts}
                          column="name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors?.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={
                            [
                              OPEN,
                              FOR_APPROVAL,
                              APPROVED,
                              STATUS_PAID,
                              CANCELLED,
                              STATUS_ALLOW_EDIT,
                              STATUS_FULFILLED,
                            ] || []
                          }
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="PO #"
                          name="po_no"
                          formItemLayout={smallFormItemLayout}
                          value={search_state[transaction_counter.key]}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <TextFieldGroup
                          label="Reference"
                          name="reference"
                          formItemLayout={smallFormItemLayout}
                          value={search_state.reference}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Approved POs"
                          name="approved_purchase_orders"
                          value={search_state.approved_purchase_orders}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              approved_purchase_orders: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                      <Col span={8}>
                        <CheckboxFieldGroup
                          label="Is Unpaid"
                          name="is_unpaid"
                          checked={search_state.is_unpaid}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.checked,
                              setState: setSearchState,
                            });
                          }}
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={
                                <i className="fa-solid fa-magnifying-glass pad-right-8"></i>
                              }
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  page_size,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: { ...search_state },
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      <div
        style={{
          background: "#fff",
          padding: 24,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <Row>
          <Col span={12}>
            <span className="module-title">{title}</span>
          </Col>
          {/* <Col span={12} className="has-text-right">
            <Button
              type="link"
              onClick={() => {
                navigate("/cashier");
              }}
            >
              Go Back Cashiering
            </Button>
          </Col> */}
        </Row>

        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: {
                  ...state,
                  items: state.items.filter((o) => !isEmpty(o.stock?._id)),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
                setLoadingState,
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    label={transaction_counter.label}
                    value={state[transaction_counter.key]}
                    error={errors.remarks}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}
            <DatePickerFieldGroup
              label="Date"
              name="date"
              value={state.date || null}
              onChange={(value) => {
                onChange({
                  key: "date",
                  value: value,
                  setState,
                });
              }}
              error={errors.date}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Supplier"
                  value={state.account?.name}
                  onFocus={() => {
                    onSupplierSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onSupplierSearch({ value, setOptions })}
                  onChange={(index) => {
                    const account = options.accounts?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      account,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.accounts}
                  column="name"
                  error={errors.account}
                  onAddItem={() => accountFormModal.current.open()}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  type="number"
                  step={1}
                  disabled={isEmpty(state.account?._id)}
                  label="Terms"
                  name="terms"
                  value={state.account?.terms}
                  onChange={(e) => {
                    const target = e.target;
                    setState((prevState) => ({
                      ...prevState,
                      account: {
                        ...prevState.account,
                        terms: target.value,
                      },
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Date Needed"
                  name="date_needed"
                  value={state.date_needed || null}
                  onChange={(value) => {
                    onChange({
                      key: "date_needed",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.date_needed}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  label="Reference"
                  name="reference"
                  value={state.reference}
                  error={errors.reference}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />
            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <Divider></Divider>
            {/* <Row>
              <Col span={12}>
                <Button
                  onClick={() => {
                    if (state.project?._id) {
                      axios
                        .post("/api/project-estimates/estimates", {
                          project_id: state.project?._id,
                        })
                        .then((response) => {
                          setState((o) => ({
                            ...o,
                            estimates: [
                              ...response.data.map((o) => {
                                const estimate_quantity = o.quantity;
                                delete o.price;
                                delete o.quantity;
                                return {
                                  ...o,
                                  estimate_quantity,
                                };
                              }),
                            ],
                          }));
                        })
                        .catch((err) => {
                          return message.error(
                            "There was an error processing your request"
                          );
                        });
                    }
                  }}
                >
                  Search Estimates
                </Button>
              </Col>
            </Row> */}
            {/* <div className="m-t-1">
              <Table
                dataSource={addKeysToArray([...(state.estimates || [])])}
                columns={estimates_column}
                pagination={true}
                rowClassName={(record, index) => {
                  if (record.footer === 1) {
                    return "footer-summary has-text-weight-bold";
                  }
                }}
              />
            </div>

            <Button
              className="m-t-1"
              onClick={() => {
                setState((prevState) => {
                  const estimates = [...(prevState.estimates || [])]
                    .filter((o) => o.quantity > 0)
                    .map((o) => {
                      const est_id = o._id;

                      return {
                        ...o,
                        est_id,
                      };
                    });

                  const items = [...prevState.items, ...estimates];

                  return {
                    ...prevState,
                    items,
                    estimates: [...prevState.estimates].map((o) => {
                      return {
                        ...o,
                        quantity: "",
                        price: "",
                        amount: "",
                      };
                    }),
                  };
                });
              }}
            >
              Add to PO
            </Button>

            <Divider></Divider> */}

            <Table
              dataSource={addKeysToArray([
                ...state.items,
                {
                  footer: 1,
                  quantity: sumBy(state.items, (o) => round(o.quantity)),
                  case_quantity: sumBy(state.items, (o) =>
                    round(o.case_quantity)
                  ),
                  amount: sumBy(state.items, (o) => round(o.amount)),
                },
              ])}
              columns={items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              loading_state={loading_state}
              url={url}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onDelete={() => {
                onDelete({
                  id: state._id,
                  url,
                  user: auth.user,
                  setLoadingState,
                  cb: () => {
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      setLoadingState,
                      advance_search: { ...search_state },
                    });
                  },
                });
              }}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  setLoading,
                  setLoadingState,
                  advance_search: { ...search_state },
                });
              }}
              close_label="APPROVE"
              onClose={() => {
                onUpdateStatus({
                  url,
                  state,
                  approval_status: APPROVED,
                  user: auth.user,
                  setLoadingState,
                  button_name: "APPROVE",
                  cb: () => {
                    edit({
                      record: state,
                      setState,
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                });
              }}
              has_print={!isEmpty(state._id)}
              has_cancel={!isEmpty(state._id)}
              onPrint={() => {
                window.open(`/print/${transaction}/${state._id}`, "_tab");
              }}
              // has_save={can_edit}
              save_statuses={[
                OPEN,
                FOR_APPROVAL,
                STATUS_ALLOW_EDIT,
                null,
                undefined,
              ]}
              additional_buttons={[
                state.status?.approval_status === APPROVED && (
                  <Button
                    key="allowed_edit"
                    className="button control"
                    onClick={(e) => {
                      e.preventDefault();
                      confirm({
                        title: "Allow Edit Transaction",
                        content: "Would you like to confirm?",
                        okText: "Allow Edit",
                        cancelText: "No",
                        onOk: () => {
                          onUpdateStatus({
                            url,
                            state,
                            approval_status: STATUS_ALLOW_EDIT,
                            user: auth.user,
                            cb: () => {
                              edit({
                                record: state,
                                setState,
                                setErrors,
                                setRecords,
                                url,
                                date_fields,
                              });
                            },
                          });
                        },
                        onCancel: () => {},
                      });
                    }}
                  >
                    Allowed Edit
                  </Button>
                ),
                ![CANCELLED].includes(state.status?.approval_status) && (
                  <Button
                    className="button control"
                    onClick={(e) => {
                      e.preventDefault();
                      confirm({
                        title: "Fulfill Transaction",
                        content: "Would you like to confirm?",
                        okText: "Close Fulfilled",
                        cancelText: "No",
                        onOk: () => {
                          onUpdateStatus({
                            url,
                            state,
                            approval_status: STATUS_FULFILLED,
                            user: auth.user,
                            cb: () => {
                              edit({
                                record: state,
                                setState,
                                setErrors,
                                setRecords,
                                url,
                                date_fields,
                              });
                              return message.success("PO Fulfilled");
                            },
                          });
                        },
                        onCancel: () => {},
                      });
                    }}
                  >
                    Close Fulfilled
                  </Button>
                ),
              ]}
            />
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  if (
                    hasAccess({
                      auth,
                      access: ACCESS_OPEN,
                      location,
                    })
                  ) {
                    edit({
                      record,
                      setState: (record) => {
                        setState({
                          ...record,
                          items: [...record.items],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  }
                },
              };
            }}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page, page_size) => {
                setPageSize(page_size);
                onSearch({
                  page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              },
              total: total_records,
              pageSize: page_size,
            }}
          />
        )}
      </div>
    </Content>
  );
}
